import { render } from "./Logs.vue?vue&type=template&id=3c980fed"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=3c980fed&lang=css"
import "./Logs.vue?vue&type=style&index=1&id=3c980fed&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__